// 第1张
const imgAllA = {
    JP: {
        pc: 'https://websiteoss.ecoflow.com/upload/image/1723685861099/13%E6%8E%A5%E5%8F%A3.jpg',
        h5: 'https://websiteoss.ecoflow.com/upload/image/1723685861098/13%E6%8E%A5%E5%8F%A3%20(1).jpg',
    },
    NA: {
        pc: 'https://websiteoss.ecoflow.com/upload/image/1724663476316/t1.jpg',
        h5: 'https://websiteoss.ecoflow.com/upload/image/1724924455723/ccc2.jpg',
    },
    EU: {
        pc: 'https://websiteoss.ecoflow.com/upload/image/1733200856753/eupc.jpg',
        h5: 'https://websiteoss.ecoflow.com/upload/image/1733200856236/euh5.jpg',
    },
    UK: {
        pc: 'https://websiteoss.ecoflow.com/upload/image/1725163102586/ukPC1.jpg',
        h5: 'https://websiteoss.ecoflow.com/upload/image/1725163102759/ukH1.jpg',
    },
    DE: {
        pc: 'https://websiteoss.ecoflow.com/upload/image/1733200855722/depc.jpg',
        h5: 'https://websiteoss.ecoflow.com/upload/image/1733200855533/deh5.jpg',
    },
    FR: {
        pc: 'https://websiteoss.ecoflow.com/upload/image/1733200856062/frpc.jpg',
        h5: 'https://websiteoss.ecoflow.com/upload/image/1733200855947/frh5.jpg',
    },
    IT: {
        pc: 'https://websiteoss.ecoflow.com/upload/image/1733200856410/itpc.jpg',
        h5: 'https://websiteoss.ecoflow.com/upload/image/1733200856575/ith5.jpg',
    },
    ES: {
        pc: 'https://websiteoss.ecoflow.com/upload/image/1733200622548/eupc1.jpg',
        h5: 'https://websiteoss.ecoflow.com/upload/image/1733200622344/euh51.jpg',
    },
    PH: {
        pc: 'https://websiteoss.ecoflow.com/upload/image/1751010201453/1.jpg',
        h5: 'https://websiteoss.ecoflow.com/upload/image/1751010201257/1_m.png',
    },
};
const imgLocale: any = {
    jp: imgAllA.JP,
    us: imgAllA.NA,
    ca: imgAllA.NA,
    br: imgAllA.NA,
    mx: imgAllA.NA,
    uk: imgAllA.UK,
    eu: imgAllA.EU,
    de: imgAllA.DE,
    fr: imgAllA.FR,
    it: imgAllA.IT,
    es: imgAllA.ES,
    ph: imgAllA.PH,
};
export default imgLocale;
